import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

import { client } from 'core/http';

export default function useWelcomeMail() {
  const [sending, setSending] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const send = useCallback(
    (userId: number) => {
      setSending(true);

      return client()
        .post(`users/${userId}/welcome`)
        .then(
          () =>
            enqueueSnackbar('Tervetuloa sähköposti lähetty', {
              variant: 'success'
            }),
          () =>
            enqueueSnackbar('Tervetuloa sähköpostin lähettäminen epäonnistui', {
              variant: 'error'
            })
        )
        .finally(() => setSending(false));
    },
    [enqueueSnackbar]
  );

  return { send, sending };
}
